import Login from '../components/Login'

export function LoginPage() {
  return <Login />
}
